import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLogStateMachine } from '@/idv/hooks';
import CameraAccessDenied from '../../../components/camera-access-denied';
import CameraAccessRequest from '../../../components/camera-access-request';
import CameraError from '../../../components/camera-error';
import CaptureRetryPrompt from '../../components/capture-retry-prompt';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import BackPhotoCapture from '../back-photo-capture';
import Consent from '../consent';
import DesktopCapture from '../desktop-capture';
import DesktopProcessing from '../desktop-processing';
import DesktopSelfie from '../desktop-selfie';
import DesktopSelfieRetry from '../desktop-selfie-retry';
import FrontPhotoCapture from '../front-photo-capture';
import IdDocCountryAndType from '../id-doc-country-and-type';
import MobileFallbackUpload from '../mobile-fallback-upload';
import Processing from '../processing';
import SelfiePhoto from '../selfie-photo';
type RouterProps = {
  onDone: () => void;
};
const Router = t0 => {
  const $ = _c(63);
  const {
    onDone
  } = t0;
  const [state, send] = useIdDocMachine();
  let t1;
  if ($[0] !== state) {
    t1 = state.matches("complete") || state.matches("failure");
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isDone = t1;
  useLogStateMachine("id-doc", state);
  let t2;
  let t3;
  if ($[2] !== isDone || $[3] !== onDone) {
    t2 = () => {
      if (isDone) {
        onDone();
      }
    };
    t3 = [isDone, onDone];
    $[2] = isDone;
    $[3] = onDone;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (state.matches("countryAndType")) {
    let t4;
    if ($[6] !== send) {
      t4 = data => send({
        type: "receivedCountryAndType",
        payload: data
      });
      $[6] = send;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== state.context.authToken || $[9] !== state.context.device || $[10] !== state.context.idDoc.type || $[11] !== state.context.requirement.config.supportedCountryAndDocTypes || $[12] !== state.context.requirement.documentRequestId || $[13] !== state.context.sandboxOutcome || $[14] !== t4) {
      t5 = <IdDocCountryAndType authToken={state.context.authToken} device={state.context.device} supportedCountryAndDocTypes={state.context.requirement.config.supportedCountryAndDocTypes} sandboxOutcome={state.context.sandboxOutcome} selectedDocType={state.context.idDoc.type} documentRequestId={state.context.requirement.documentRequestId} onSubmitDocType={t4} />;
      $[8] = state.context.authToken;
      $[9] = state.context.device;
      $[10] = state.context.idDoc.type;
      $[11] = state.context.requirement.config.supportedCountryAndDocTypes;
      $[12] = state.context.requirement.documentRequestId;
      $[13] = state.context.sandboxOutcome;
      $[14] = t4;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  if (state.matches("consent")) {
    let t4;
    let t5;
    if ($[16] !== send) {
      t4 = () => send({
        type: "consentReceived"
      });
      t5 = () => send({
        type: "navigatedToPrev"
      });
      $[16] = send;
      $[17] = t4;
      $[18] = t5;
    } else {
      t4 = $[17];
      t5 = $[18];
    }
    let t6;
    if ($[19] !== state.context.authToken || $[20] !== state.context.device || $[21] !== state.context.onboardingConfig.logoUrl || $[22] !== state.context.onboardingConfig.orgName || $[23] !== state.context.onboardingConfig.privacyPolicyUrl || $[24] !== t4 || $[25] !== t5) {
      t6 = <Consent authToken={state.context.authToken} device={state.context.device} onConsentSubmit={t4} onNavigatedToPrev={t5} tenantLogoUrl={state.context.onboardingConfig.logoUrl} tenantName={state.context.onboardingConfig.orgName} tenantPrivacyPolicyUrl={state.context.onboardingConfig.privacyPolicyUrl} />;
      $[19] = state.context.authToken;
      $[20] = state.context.device;
      $[21] = state.context.onboardingConfig.logoUrl;
      $[22] = state.context.onboardingConfig.orgName;
      $[23] = state.context.onboardingConfig.privacyPolicyUrl;
      $[24] = t4;
      $[25] = t5;
      $[26] = t6;
    } else {
      t6 = $[26];
    }
    return t6;
  }
  if (state.matches("mobileRequestCameraAccess")) {
    let t4;
    if ($[27] !== send) {
      t4 = <CameraAccessRequest onClose={() => send({
        type: "navigatedToPrev"
      })} onCameraAccessDenied={() => send({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      })} onCameraError={cause => send({
        type: "cameraErrored",
        payload: {
          cause
        }
      })} onSuccess={() => send({
        type: "cameraAccessGranted",
        payload: {
          status: "granted"
        }
      })} />;
      $[27] = send;
      $[28] = t4;
    } else {
      t4 = $[28];
    }
    return t4;
  }
  if (state.matches("mobileCameraAccessDenied")) {
    let t4;
    if ($[29] !== send) {
      t4 = () => send({
        type: "navigatedToPrev"
      });
      $[29] = send;
      $[30] = t4;
    } else {
      t4 = $[30];
    }
    let t5;
    if ($[31] !== state.context.device || $[32] !== t4) {
      t5 = <CameraAccessDenied device={state.context.device} onClose={t4} />;
      $[31] = state.context.device;
      $[32] = t4;
      $[33] = t5;
    } else {
      t5 = $[33];
    }
    return t5;
  }
  if (state.matches("mobileCameraErrored")) {
    let t4;
    if ($[34] !== send) {
      t4 = () => send({
        type: "navigatedToPrev"
      });
      $[34] = send;
      $[35] = t4;
    } else {
      t4 = $[35];
    }
    const t5 = state.context.cameraErrorCause ?? "other-error";
    let t6;
    if ($[36] !== t4 || $[37] !== t5) {
      t6 = <CameraError onBack={t4} cause={t5} />;
      $[36] = t4;
      $[37] = t5;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    return t6;
  }
  if (state.matches("mobileFrontImageCapture")) {
    let t4;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <FrontPhotoCapture />;
      $[39] = t4;
    } else {
      t4 = $[39];
    }
    return t4;
  }
  if (state.matches("mobileFrontPhotoFallback")) {
    let t4;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MobileFallbackUpload imageType="front" />;
      $[40] = t4;
    } else {
      t4 = $[40];
    }
    return t4;
  }
  if (state.matches("mobileFrontImageRetry")) {
    let t4;
    if ($[41] !== send) {
      t4 = <CaptureRetryPrompt imageType="front" onComplete={payload => send({
        type: "receivedImage",
        payload
      })} />;
      $[41] = send;
      $[42] = t4;
    } else {
      t4 = $[42];
    }
    return t4;
  }
  if (state.matches("desktopFrontImage")) {
    let t4;
    if ($[43] !== send) {
      t4 = <DesktopCapture imageType="front" onBack={() => send({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_0 => send({
        type: "receivedImage",
        payload: payload_0
      })} />;
      $[43] = send;
      $[44] = t4;
    } else {
      t4 = $[44];
    }
    return t4;
  }
  if (state.matches("desktopFrontImageRetry")) {
    let t4;
    if ($[45] !== send) {
      t4 = <DesktopCapture imageType="front" isRetry={true} onBack={() => send({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_1 => send({
        type: "receivedImage",
        payload: payload_1
      })} />;
      $[45] = send;
      $[46] = t4;
    } else {
      t4 = $[46];
    }
    return t4;
  }
  if (state.matches("mobileBackImageCapture")) {
    let t4;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <BackPhotoCapture />;
      $[47] = t4;
    } else {
      t4 = $[47];
    }
    return t4;
  }
  if (state.matches("mobileBackPhotoFallback")) {
    let t4;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MobileFallbackUpload imageType="back" />;
      $[48] = t4;
    } else {
      t4 = $[48];
    }
    return t4;
  }
  if (state.matches("mobileBackImageRetry")) {
    let t4;
    if ($[49] !== send) {
      t4 = <CaptureRetryPrompt imageType="back" onComplete={payload_2 => send({
        type: "receivedImage",
        payload: payload_2
      })} />;
      $[49] = send;
      $[50] = t4;
    } else {
      t4 = $[50];
    }
    return t4;
  }
  if (state.matches("desktopBackImage")) {
    let t4;
    if ($[51] !== send) {
      t4 = <DesktopCapture imageType="back" onBack={() => send({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_3 => send({
        type: "receivedImage",
        payload: payload_3
      })} />;
      $[51] = send;
      $[52] = t4;
    } else {
      t4 = $[52];
    }
    return t4;
  }
  if (state.matches("desktopBackImageRetry")) {
    let t4;
    if ($[53] !== send) {
      t4 = <DesktopCapture imageType="back" isRetry={true} onBack={() => send({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_4 => send({
        type: "receivedImage",
        payload: payload_4
      })} />;
      $[53] = send;
      $[54] = t4;
    } else {
      t4 = $[54];
    }
    return t4;
  }
  if (state.matches("mobileSelfieImage")) {
    let t4;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <SelfiePhoto />;
      $[55] = t4;
    } else {
      t4 = $[55];
    }
    return t4;
  }
  if (state.matches("mobileSelfieFallback")) {
    let t4;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <MobileFallbackUpload imageType="selfie" />;
      $[56] = t4;
    } else {
      t4 = $[56];
    }
    return t4;
  }
  if (state.matches("mobileSelfieImageRetry")) {
    let t4;
    if ($[57] !== send) {
      t4 = <CaptureRetryPrompt imageType="selfie" onComplete={payload_5 => send({
        type: "receivedImage",
        payload: payload_5
      })} />;
      $[57] = send;
      $[58] = t4;
    } else {
      t4 = $[58];
    }
    return t4;
  }
  if (state.matches("desktopSelfieImage")) {
    let t4;
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DesktopSelfie />;
      $[59] = t4;
    } else {
      t4 = $[59];
    }
    return t4;
  }
  if (state.matches("desktopSelfieImageRetry")) {
    let t4;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DesktopSelfieRetry />;
      $[60] = t4;
    } else {
      t4 = $[60];
    }
    return t4;
  }
  if (state.matches("mobileProcessing")) {
    let t4;
    if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Processing />;
      $[61] = t4;
    } else {
      t4 = $[61];
    }
    return t4;
  }
  if (state.matches("desktopProcessing")) {
    let t4;
    if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DesktopProcessing />;
      $[62] = t4;
    } else {
      t4 = $[62];
    }
    return t4;
  }
  return null;
};
export default Router;